module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"UNAUTHORIZED","message":"You do not have access to see the contents of this page.<br>Please try again, with a different user account"},"da":{"title":"IKKE AUTORISERET","message":"Du har ikke de nødvendige brugerettigheder til at se indholdet på denne side.<br>Prøv venligst igen med en anden brugerkonto."}}')
  delete Component.options._Ctor
}
